import { useQuery } from '@tanstack/react-query';
import { API } from '../services/api';

export interface Project {
  id: string;
  name: string;
  code: string;
  description?: string;
  icon?: string;
}

export const useProjects = (spaceSlug: string) => {
  return useQuery({
    queryKey: ['spaces', spaceSlug, 'projects'],
    queryFn: async () => {
      const data = await API.projects.getAll(spaceSlug);
      return data.projects;
    },
    enabled: !!spaceSlug,
  });
};

export const useProject = (spaceSlug: string, projectCode: string) => {
  return useQuery({
    queryKey: ['spaces', spaceSlug, 'projects', projectCode],
    queryFn: async () => {
      const data = await API.projects.get(spaceSlug, projectCode);
      return data.project;
    },
    enabled: !!spaceSlug && !!projectCode,
  });
};
